import React from "react";
import Breadcrump from "../../components/Breadcrump";
import ListPage from "../brands/ListPage";
const Services = () => {
  const Icons = {
    installation: (
      <svg
        viewBox="0 0 48 48"
        fill="none"
        stroke="#8ab7ea"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="24" cy="16" r="6" />
        <path d="M12 36c0-6.627 5.373-12 12-12s12 5.373 12 12" />
        <path d="M8 40h32" />
        <path d="M24 10V6M18 12l-3-3M30 12l3-3" />
      </svg>
    ),
    breakdown: (
      <svg
        viewBox="0 0 48 48"
        fill="none"
        stroke="#8ab7ea"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M24 6L8 14v12c0 9 7 17 16 19 9-2 16-10 16-19V14L24 6z" />
        <polyline points="18,24 22,28 30,20" />
      </svg>
    ),
    customization: (
      <svg
        viewBox="0 0 48 48"
        fill="none"
        stroke="#8ab7ea"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect x="8" y="16" width="32" height="24" rx="3" />
        <path d="M16 16v-4a8 8 0 0116 0v4" />
        <line x1="24" y1="26" x2="24" y2="32" />
        <circle cx="24" cy="25" r="2" fill="#8ab7ea" stroke="none" />
      </svg>
    ),
    upgrades: (
      <svg
        viewBox="0 0 48 48"
        fill="none"
        stroke="#8ab7ea"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect x="6" y="6" width="14" height="14" rx="2" />
        <rect x="28" y="6" width="14" height="14" rx="2" />
        <rect x="6" y="28" width="14" height="14" rx="2" />
        <line x1="35" y1="28" x2="35" y2="42" />
        <line x1="28" y1="35" x2="42" y2="35" />
      </svg>
    ),
    filtration: (
      <svg
        viewBox="0 0 48 48"
        fill="none"
        stroke="#8ab7ea"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect x="8" y="8" width="32" height="32" rx="3" />
        <line x1="8" y1="20" x2="40" y2="20" />
        <line x1="8" y1="32" x2="40" y2="32" />
        <line x1="20" y1="8" x2="20" y2="40" />
      </svg>
    ),
    cylinder: (
      <svg
        viewBox="0 0 48 48"
        fill="none"
        stroke="#8ab7ea"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect x="6" y="10" width="36" height="28" rx="3" />
        <line x1="18" y1="10" x2="18" y2="38" />
        <line x1="30" y1="10" x2="30" y2="38" />
        <line x1="6" y1="20" x2="18" y2="20" />
        <line x1="6" y1="28" x2="18" y2="28" />
        <line x1="30" y1="20" x2="42" y2="20" />
        <line x1="30" y1="28" x2="42" y2="28" />
      </svg>
    ),
  };
  const data = {
    subtitle: "OUR BENEFIT",
    title: "At ITH Hydraulics Pvt Ltd.",
    desc: "We provide end-to-end hydraulic solutions to ensure seamless operations for our customers.",
    cards: [
      {
        icon: "installation",
        title: "Installation & Commissioning",
        text: "Expert setup and integration of hydraulic systems for optimal performance.",
      },
      {
        icon: "breakdown",
        title: "Breakdown Support & Repairs",
        text: "Fast response and on-site troubleshooting to minimize disruptions.",
      },
      {
        icon: "customization",
        title: "Customization & Retrofits",
        text: "Tailor-made hydraulic solutions designed to meet unique industrial needs.",
      },
      {
        icon: "upgrades",
        title: "Hydraulic System Upgrades",
        text: "Modernizing and optimizing existing systems for better efficiency and performance.",
      },
      {
        icon: "filtration",
        title: "Oil Filtration & Contamination Control",
        text: "Enhancing machine life by ensuring clean hydraulic oil.",
      },
      {
        icon: "cylinder",
        title: "Hydraulic Cylinder & Power Unit Overhauling",
        text: "Comprehensive refurbishment and performance enhancement.",
      },
    ],
  };

  return (
    <>
      <Breadcrump title="Services" />

      {/* OUR BENEFIT */}
      <section className="ith-benefit">
        <div className="container ith-benefit__inner">
          {/* Section Header */}
          <p className="ith-benefit__subtitle">{data.subtitle}</p>
          <h2 className="ith-benefit__title">{data.title}</h2>
          <p className="ith-benefit__desc">{data.desc}</p>

          {/* Cards Grid */}
          <div className="ith-benefit__grid">
            {data.cards.map((card, index) => (
              <div className="ith-benefit__card" key={index}>
                {/* LEFT: icon on top, rotated number on bottom */}
                <div className="ith-benefit__left">
                  <div className="ith-benefit__icon">
                    {Icons[card.icon] || Icons.installation}
                  </div>
                  <span className="ith-benefit__card-number">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                </div>

                {/* RIGHT: title + description */}
                <div className="ith-benefit__right">
                  <h4 className="ith-benefit__card-title">{card.title}</h4>
                  <p className="ith-benefit__card-text">{card.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* BRAND */}
      <ListPage />
    </>
  );
};

export default Services;
